import React from 'react';
import { SummaryBlock } from './SummaryBlock';
import { Col, Image, Row } from 'react-bootstrap';
import pixel from '../../assets/1x1.png';
import { useSiteState } from '../../state/state';

export const Logo = () => {
    const { settings } = useSiteState();

    return settings ? (
        <SummaryBlock display className='text-center'>
            <Row>
                <Col>
                    <Image className='logo' src={pixel} alt='Company Logo' />
                </Col>
            </Row>
            <Row>
                <Col className="mt-1">
                    <small><strong>{settings?.footerText}</strong></small>
                </Col>
            </Row>
            <Row>
                <Col>
                    <small className="text-dim">Powered by Pegasus - An Avetta Company</small>
                </Col>
            </Row>
        </SummaryBlock>
    ) : null;
}
